export interface IRecall {
  id: string,
  localFsaDescLocal: string,
  govtRecallNumber: string | null,
  govtRecallDescLocal: string | null,
  repairDate: string | null,
  repairDealerCode: number | null,
  recallTime: string | null,
  vin: string,
  dealerAddress: string | null,
  dealerTradeName: string | null,
  fsaType: string,
  isChecked: boolean,
  lastPrintDate: string | null,
  launchDate: string,
  parts: string | null,
  isCSRecall: boolean,
}

export interface IRecallFromQuotationApi {
  recallCampainId: string,
  recallCampainDescription: string,
}
